import { FC } from 'react'
import { Grid, Heading, Icon, Typography } from '~ui'

import styles from './number-of-views.module.scss'

const { Text } = Typography

export type NumberOfViewsProps = {
  starName: string
  colorGlow: GThemeColorsNew
  numberOfViews: number | string
}

const NumberOfViews: FC<NumberOfViewsProps> = ({
  starName = 'Alicia Keys',
  colorGlow = 'g-green-dark',
  numberOfViews = 430,
}) => (
  <Grid gap="1rem" gridAutoFlow="column" alignItems="center" className={styles.container}>
    <Icon name="people" width="2em" height="2em" glowColor={colorGlow} glow />{' '}
    <Text>
      <Heading colorGlow={colorGlow} Tag="span">
        {numberOfViews} PEOPLE
      </Heading>{' '}
      viewed {starName} in the past hour.
    </Text>
  </Grid>
)

export default NumberOfViews
